(() => {
  const pathParts = decodeURIComponent(window.location.pathname.toLowerCase()).split("/").filter(Boolean);
  const collectionHandle = pathParts.find((part, index) => {
    return (pathParts[index - 1] === "collections" || pathParts[index - 1] === "search") && part === "plotters";
  });

  if (collectionHandle !== "plotters") return;

  const widthLabels = new Map([
    ["17 pulgadas", "A2 (17 pulgadas)"],
    ["24 pulgadas", "A1 (24 pulgadas)"],
    ["36 pulgadas", "A0 (36 pulgadas)"],
    ["44 pulgadas", "44 pulgadas (111,8 cm)"],
    ["64 pulgadas", "64 pulgadas (162,6 cm)"],
  ]);
  const optionNameSelector = ".cloud-search-filter-value__name";
  const appliedValuesSelector = ".cloud-search-applied-filter__values";
  let translationScheduled = false;

  function compact(value) {
    return (value || "").replace(/\s+/g, " ").trim();
  }

  function matchingElements(root, selector) {
    const elements = [];
    if (root instanceof Element && root.matches(selector)) elements.push(root);
    if (root?.querySelectorAll) elements.push(...root.querySelectorAll(selector));
    return elements;
  }

  function translateOptionNames(root = document) {
    matchingElements(root, optionNameSelector).forEach((name) => {
      const row = name.closest(".cloud-search-filter-value");
      const source = row?.getAttribute("data-filter-value") || name.dataset.mastonerPlotterWidthSource || compact(name.textContent);
      const target = widthLabels.get(source);
      if (!target || compact(name.textContent) === target) return;

      name.dataset.mastonerPlotterWidthSource = source;
      name.textContent = target;
    });
  }

  function translateAppliedValues(root = document) {
    matchingElements(root, appliedValuesSelector).forEach((container) => {
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);

      nodes.forEach((node) => {
        const text = compact(node.nodeValue);
        for (const [source, target] of widthLabels) {
          if (text === source || text.startsWith(`${source} (`) || text.endsWith(`: ${source}`)) {
            node.nodeValue = node.nodeValue.replace(source, target);
            break;
          }
        }
      });
    });
  }

  function translateAll(root = document) {
    translateOptionNames(root);
    translateAppliedValues(root);
  }

  function scheduleTranslation() {
    if (translationScheduled) return;
    translationScheduled = true;
    window.requestAnimationFrame(() => {
      translationScheduled = false;
      translateAll(document);
    });
  }

  translateAll(document);
  new MutationObserver(scheduleTranslation).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
  window.addEventListener("popstate", scheduleTranslation);
  window.addEventListener("mastoner:xcloud-urlchange", scheduleTranslation);
})();
